import { apiCall } from "./store-util";

export const getThemes = () => {
    return apiCall("get-relax-themes").then((response: any) => {
        const res = JSON.parse(response.toString());
        return res;
    });
}